export default __webpack_public_path__ + "static/media/firelogs.a90e2f77.jpg";